module.exports = __webpack_public_path__ + "static/media/notification.3cad9d87.svg";